import { Cell } from "@ton/core";
export const isValidBoc = (boc) => {
    try {
        return !!Cell.fromBase64(boc);
    }
    catch {
        return false;
    }
};
//# sourceMappingURL=isValidBoc.js.map